/**
 * Küresel yükleme göstergesinin durum makinesi (görsel kısmı: components/LoadingIndicator).
 *
 * Eski davranış her istekte tüm ekranı karartıyordu; 80 ms'lik bir GET bile ekranı bir anlığına
 * söndürüp yakıyordu. Üç kural bunu bitirir:
 *
 *  1) SAYAÇLI  — paralel isteklerde ilk biten göstergeyi kapatmaz (eski kod düz display:none idi).
 *  2) GECİKMELİ (SHOW_DELAY) — bundan kısa süren istekler HİÇBİR ŞEY göstermez. İsteklerin
 *     büyük çoğunluğu buraya düşer, yani ekran artık her tıklamada titremez.
 *  3) EN AZ GÖRÜNME (MIN_VISIBLE) — bir kez gösterdiysek göz seçebilsin diye o kadar kalır;
 *     eşiği yeni geçmiş bir istek göstergeyi yakıp hemen söndürmez.
 *
 * İki ağırlık vardır:
 *  - 'bar'      → yalnız üstteki ince çubuk; ekranı bloklamaz (okuma çağrıları).
 *  - 'blocking' → çubuk + karartma + spinner; tıklamayı bloklar (mutasyonlar).
 *                 Bloklayan istekte ŞEFFAF kalkan isteğin BAŞINDA konur (gecikme beklemez):
 *                 200 ms'lik bir POST'ta bile çift tıklama ikinci bir isteği doğurmasın diye.
 *                 Gözle görülen karartma yine SHOW_DELAY sonrası gelir.
 */

const SHOW_DELAY = 300;
const MIN_VISIBLE = 400;

export const LOADER_BAR = 'bar';
export const LOADER_BLOCKING = 'blocking';

let total = 0;        // sürmekte olan tüm istekler (gösterge isteyenler)
let blocking = 0;     // bunların ekranı bloklaması gerekenleri
let visible = false;  // görsel gösterge (çubuk/karartma) ekranda mı
let shownAt = 0;
let showTimer = null;
let hideTimer = null;

let snapshot = {shield: false, bar: false, dim: false};
const listeners = new Set();

function computeSnapshot() {
    return {
        // Tıklama kalkanı: anında, gecikmesiz — çift göndermeyi bu engelliyor.
        shield: blocking > 0,
        bar: visible,
        // Karartma yalnız bloklayan istek SÜRERKEN; MIN_VISIBLE kuyruğunda sadece çubuk kalır,
        // yani işlem biter bitmez ekran serbest görünür.
        dim: visible && blocking > 0
    };
}

function publish() {
    const next = computeSnapshot();
    if (next.shield === snapshot.shield && next.bar === snapshot.bar && next.dim === snapshot.dim)
        return;

    snapshot = next;
    listeners.forEach(fn => fn(snapshot));
}

function show() {
    showTimer = null;
    visible = true;
    shownAt = Date.now();
    publish();
}

function hide() {
    hideTimer = null;
    visible = false;
    publish();
}

function scheduleShow() {
    // Kesintisiz aktivite göstergeyi söndürüp yakmasın: bekleyen gizleme iptal edilir.
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
    if (visible || showTimer)
        return;

    showTimer = setTimeout(show, SHOW_DELAY);
}

function scheduleHide() {
    if (showTimer) {
        clearTimeout(showTimer);
        showTimer = null;
    }
    if (!visible || hideTimer)
        return;

    hideTimer = setTimeout(hide, Math.max(0, MIN_VISIBLE - (Date.now() - shownAt)));
}

export function beginRequest(weight = LOADER_BAR) {
    total++;
    if (weight === LOADER_BLOCKING)
        blocking++;

    scheduleShow();
    publish();
}

export function endRequest(weight = LOADER_BAR) {
    total = Math.max(0, total - 1);
    if (weight === LOADER_BLOCKING)
        blocking = Math.max(0, blocking - 1);

    if (total === 0)
        scheduleHide();

    publish();
}

/** Oturum kapanışı gibi kesintilerde sayaç takılı kalırsa göstergeyi sıfırlayan emniyet valfi. */
export function resetLoadingIndicator() {
    total = 0;
    blocking = 0;
    if (showTimer) clearTimeout(showTimer);
    if (hideTimer) clearTimeout(hideTimer);
    showTimer = hideTimer = null;
    visible = false;
    publish();
}

export function subscribeLoading(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function getLoadingSnapshot() {
    return snapshot;
}
